export class Hand {
  

  constructor (scene) {
    const loader = new THREE.OBJLoader();  
    
    loader.load(
      'models/hand.obj',
      (object) => {
        scene.add( object );
        var scale = 100;
        object.scale.set(scale, scale, scale);
        object.rotation.x = 1.20;
        object.rotation.y = -2.04;
        object.rotation.z = -1.68;
        object.children[0].material = new THREE.MeshDepthMaterial( { color: 0x000000, polygonOffset: true, polygonOffsetFactor: 1, polygonOffsetUnits: 1 } );

      
        // wireframe
        var mat = new THREE.MeshBasicMaterial( { color: 0xfffffff, wireframe: true, transparent: true, opacity: 0.2 });
        var wireframe = new THREE.Mesh(object.children[0].geometry, mat);
        object.add( wireframe );

        this.object = object;
      },
      (xhr) => { console.log( ( xhr.loaded / xhr.total * 100 ) + '% loaded' ); },
      (error) => { console.log( 'An error happened' ); }
    );
  }
}


// WEBPACK FOOTER //
// ./src/scene/hand.js